@if(mode==="edit" || mode==="add"){
<div pplFocusTrap>
<div class="ppl-mt20">
  <form nz-form nz-row [formGroup]="enrollmentStatus" class="ppl-p0">
    @if(isAttrAvailable('status')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="status" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'status']">{{ getAttributes("status").label }}
          @if(getAttributes('status').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('status').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['status'] }">
              <ppl-dropdown-select formControlName="status" id="status"
              placeholder="Select Registration Status" [disabled]="mode === 'edit'"
              [options]="allowedStatus" [optionLabel]="'status'" [optionValue]="'status'"
              [attr.aria-invalid]="validationErrors['status'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['status'] ? 'status-error' : null">
              </ppl-dropdown-select>
          </div>
          @if (validationErrors['status']) {
          <span class="pl-1 error-message" id="status-error" role="alert">{{validationErrors['status']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    <div nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left"></div>


    @if(isAttrAvailable('startDate') && !disableStatus){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="startDate"
          class="ppl-form-label">{{getAttributes('startDate').label}}
          @if(getAttributes('startDate').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('startDate')?.tooltip || ''" nzTooltipPlacement="topRight">
            <!-- <nz-date-picker formControlName="startDate" [id]="'startDate'" style="height: 32px;"
              [nzDisabledDate]="disabledStartDate" [nzFormat]="'MM/dd/yyyy'"
              [nzPlaceHolder]="getAttributes('startDate').placeholder"
              [ngClass]="{'error': validationErrors['startDate'] }"></nz-date-picker> -->
              <ppl-date-picker formControlName="startDate" [id]="'startDate'"  [showIcon]="true"
              [placeholder]="getAttributes('startDate').placeholder" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
              [ariaLabel]="getAttributes('startDate').label" inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [maxDate]="minStartDate" 
              [styleClass]="validationErrors['startDate'] ? 'error' : ''"
              [attr.aria-invalid]="validationErrors['startDate'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['startDate'] ? 'startDate-error' : null">
              </ppl-date-picker>
          </div>
          @if (validationErrors['startDate']) {
          <span class="pl-1 error-message" id="startDate-error" role="alert">{{validationErrors['startDate']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if(isAttrAvailable('endDate') && !disableStatus){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

      <nz-row>

        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="endDate" class="ppl-form-label">{{getAttributes('endDate').label}}
          @if(getAttributes('endDate').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('endDate')?.tooltip || ''" nzTooltipPlacement="topRight">
            <!-- <nz-date-picker formControlName="endDate" [id]="'endDate'" style="height: 32px;" [nzFormat]="'MM/dd/yyyy'"
              [nzDisabledDate]="disabledEndDate" [nzPlaceHolder]="getAttributes('endDate').placeholder"
              [ngClass]="{'error': validationErrors['endDate'] }"></nz-date-picker> -->
              <ppl-date-picker formControlName="endDate" [id]="'endDate'"  [showIcon]="true"
              [placeholder]="getAttributes('endDate').placeholder" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
              [ariaLabel]="getAttributes('endDate').label" inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [minDate]="maxEndDate" 
              [styleClass]="validationErrors['endDate'] ? 'error' : ''"
              [attr.aria-invalid]="validationErrors['endDate'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['endDate'] ? 'endDate-error' : null">
              </ppl-date-picker>
          </div>
          @if (validationErrors['endDate']) {
          <span class="pl-1 error-message" id="endDate-error" role="alert">{{validationErrors['endDate']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if(isAttrAvailable('reason')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="reason" class="ppl-form-label"
          [authorizeField]="[pageId, tabId, 'Demographics', 'reason']">{{ getAttributes("reason").label }}
          @if(getAttributes('reason').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('reason').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['reason'] }">
            <ppl-dropdown-select formControlName="reason" id="reason" placeholder="Select Reason"
              [options]="statusReasons" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['reason']) {
          <span class="pl-1 error-message">{{validationErrors['reason']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if(isAttrAvailable('comment')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item  nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="comment" class="ppl-form-label">{{getAttributes('comment').label}}
          @if(getAttributes('comment').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('comment').tooltip}}"
          nzTooltipPlacement="topRight">
          <textarea rows="4" cols="40" nz-input formControlName="comment" nzId="comment" class="ppl-form-control"
            placeholder="{{getAttributes('comment').placeholder}}"
            [ngClass]="{'error': validationErrors['comment'] }" [attr.aria-invalid]="validationErrors['comment'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['comment'] ? 'comment-error' : null"></textarea>
          @if (validationErrors['comment']) {
          <span class="pl-1 error-message" id="comment-error" role="alert">{{validationErrors['comment']}}</span>
          }
        </nz-form-control>

      </nz-row>

    </nz-form-item>
    }
  </form>
</div>
<div class="custom-row">
  <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="cancelEdit()"></ppl-button>
  <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="save()"></ppl-button>
</div>
</div>
} @else if(mode==="read"){
@if (!disableAddStatus && !readonly) {
<div class="custom-row">
  <div class="mr-2">
    <ppl-button label="Add Status" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'"
      (click)="add()" *authorize="[pageId, tabId, 'EligibilityDates', 'section', 'edit']"></ppl-button>
  </div>
</div>
}

@if (showMoveToInPPLReviewButton && !readonly) {
<div class="custom-row">
  <div class="mr-2">
    <ppl-button label="Move to PPL Review" icon="fa fa-arrow-circle-right" [customClass]="'ghost-button'"
      [iconPosition]="'left'" (click)="moveToPPLReview()"
      *authorize="[pageId, tabId, 'MoveToInPPLReview', 'section', 'edit']"></ppl-button>
  </div>
</div>
}

@if(copyOfGridData.length > 0){
@if(isMobileView){
<div class="card-layout p-0 m-0">
  <div class="card" *ngFor="let data of copyOfGridData">
    <div class="card-item mt-2">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">Status: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.status}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>

    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">Start Date: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.startDate}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>

    @if(data.endDate) {
    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">End Date: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.endDate}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>

    }
    @if(data.reason) {
    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">Reason: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.reason}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    }
    @if(data.comment) {
    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">Comment: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.comment}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    }
    @if(showModifiedBy) {
      <div class="card-item">
        <nz-row>
          <div nz-col nzSpan="12" [nzXs]="24">
            <nz-row>
              <strong nz-col nzSpan="12" [nzXs]="11">Modified By: </strong>
              <span nz-col nzSpan="12" [nzXs]="13">{{data.modifiedBy}}</span>
            </nz-row>
          </div>
        </nz-row>
      </div>
    }
    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="11">Modified Date: </strong>
            <span nz-col nzSpan="12" [nzXs]="13">{{data.modifiedDate}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    @if(data.actions?.edit){
    <div class="btn-group mt-3 d-flex justify-content-between">
      <div class="mr-3">
        <ppl-button ariaLabel="Edit" label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="action({data: data, action: 'edit'})"></ppl-button>
      </div>
    </div>
    }

  </div>
</div>
} @else {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="copyOfGridData"
  [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
  [loadPage]="true" [actionButtons]="actionButtons">
</ppl-list-table>
}
}@else {
<nz-row>
  <p tabindex="0">No Data found</p>
</nz-row>
}



}@else if (mode==="read" && !copyOfGridData) {
<nz-row>
  <p tabindex="0">No Data found</p>
</nz-row>
}

@if(!isMobileView) {
<div class="custom-row" style="height: 0.3rem"></div>
}